import bank from './bank';
import credit from './credit';
import customer from './customer';
import documents from './documents';
import employee from './employee';
import fcu from './fcu';
import indus from './indus';
import loan from './loan';
import location from './location';
import other from './others';
import partner from './partner';
import product from './product';
import regulatedEntity from './regulatedEntity';
import rules from './rules';
import templates from './templates';

// ==============================|| Masters MENU ITEMS ||============================== //

const masters = {
	id: 'masters',
	title: 'Masters',
	type: 'group',
	children: [
		// customer, location, employee, school, collateral, loan, product, partner, insurance
		regulatedEntity,
		location,
		employee,
		loan,
		bank,
		credit,
		documents,
		fcu,
		indus,
		customer,
		partner,
		product,
		rules,
		templates,
		other,
	],
};

export default masters;
